import { render, staticRenderFns } from "./ExpedientNextEventsWidget.vue?vue&type=template&id=fb0782ca&scoped=true"
import script from "./ExpedientNextEventsWidget.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpedientNextEventsWidget.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ExpedientNextEventsWidget.vue?vue&type=style&index=0&id=fb0782ca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0782ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb0782ca')) {
      api.createRecord('fb0782ca', component.options)
    } else {
      api.reload('fb0782ca', component.options)
    }
    module.hot.accept("./ExpedientNextEventsWidget.vue?vue&type=template&id=fb0782ca&scoped=true", function () {
      api.rerender('fb0782ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/widgets/ExpedientWidgets/ExpedientNextEvents/ExpedientNextEventsWidget.vue"
export default component.exports